class observation {
    constructor(parameters) {
        this.obsewrvation = document.querySelector(".course-tabs")
        this.bindEvents()
     
    }
    bindEvents(){
        this.obsewrvation.querySelectorAll('.custom-list-observation')?.forEach(each => each.addEventListener('click', this.arrowFunction.bind(this)));
    }
    arrowFunction(event){
        document.querySelectorAll(".custom-list-observation, .custom-text-observation").forEach(el => el.classList.remove("open"));
        event.target.classList.add("open");
        event.target.nextElementSibling?.classList.add("open");
    }
}
new observation()
